module.exports = __webpack_public_path__ + "static/media/ficaremcasa.4004c482.png";